import api from './app-controller'
import ORDER_ENDPOINTS from "../routes/order-routes";

export const getOrder = async (orderId) => await api.get(`${ORDER_ENDPOINTS.GET_ORDER(orderId)}`);
export const getOrders = async () => await api.get(ORDER_ENDPOINTS.GET_ORDERS);
export const getOrdersByLimit = async (limit, page) => await api.get(ORDER_ENDPOINTS.GET_ORDERS_BY_LIMIT(limit, page));